import { SelectionChangedEvent } from "ag-grid-community";
import { MovementPatternEntity } from "domain/entity/MovementPattern/MovementPatternEntity";
import _ from "lodash";
import { INITIAL_MOVEMENT_PATTERN_COL_DEF } from "presentation/constant/MovementPattern/MovementPatternColumnDefinition";
import { MovementPatternConstant } from "presentation/constant/MovementPattern/MovementPatternConstant";
import { useMovementPatternVM } from "presentation/hook/MovementPattern/useMovementPatternVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useMovementPatternTracked } from "presentation/store/MovementPattern/MovementPatternProvider";
import RightClickMenuWithMoveAfter from "presentation/view/components/NbisRightClickMenu/RightClickMenuWithMoveAfter";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { createRef, memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Loader } from "veronica-ui-component/dist/component/core";
const MovementPatternTablePanel = () => {
    const gridRef: any = useRef(null);
    const [movementPatternState] = useMovementPatternTracked();
    const movementPatternVM = useMovementPatternVM();
    const messageBarVM = useMessageBarVM();

    // const [onTableSelectionClicked, setOnTableSelectionClicked] = useState<boolean>(false);
    const [anainfoState] = useANAInfoTracked();
    const { allowUpdate, allowCreate } = anainfoState;
    const rightClickRef: any = createRef();
    // for right click menu with move after begin
    const [showMoveCursor, setShowMoveCursor] = useState<boolean>(false);
    const [allRows, setAllRows] = useState<MovementPatternEntity[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [initialAllRows, setInitialAllRows] = useState<boolean>(true);

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();
        // setOnTableSelectionClicked(true);
        movementPatternVM.updateSelectedRows(selectedRows);
    }, [movementPatternVM])

    const handleRowDoubleClick = useCallback((entity: MovementPatternEntity) => {
        movementPatternVM.onRowDoubleClick(entity);
    }, [movementPatternVM])

    const getAllRows = useCallback(() => {
        return allRows;
    }, [allRows]);

    const getSelectedRows = useCallback(() => {
        return movementPatternState.selectedRows;
    }, [movementPatternState.selectedRows]);

    // const getShowMoveCursor = useCallback(() => {
    //     return showMoveCursor;
    // }, [showMoveCursor]);
    // //for right click menu with move after end

    // useEffect(() => {
    //     //const columnDefs = (INITIAL_MOVEMENT_PATTERN_COL_DEF?.slice());

    //     // if (!movementPatternState.selectedRows || movementPatternState.selectedRows.length <= 0) {
    //     //gridRef.current?.gridRef.current.api?.setColumnDefs(columnDefs);
    //     if (!onTableSelectionClicked) {
    //         gridRef.current?.gridRef.current.api?.deselectAll();
    //     }
    //     // }
    //     changeCursor("movement-pattern-table", getShowMoveCursor());
    // });

    // useEffect(() => {
    //     if (!onTableSelectionClicked) return;
    //     gridRef?.current?.gridRef.current.api?.deselectAll();
    //     changeCursor("movement-pattern-table", getShowMoveCursor());
    // }, [getShowMoveCursor, onTableSelectionClicked]);

    useEffect(() => {
        const handleRightClickMenu = (event: any) => {
            if (_.isEmpty(movementPatternState.selectedRows) || !allowUpdate) {
                return;
            }
            event.preventDefault();
            rightClickRef.current.show(event);
        };
        document.getElementById('myDiv')?.addEventListener("contextmenu", handleRightClickMenu);

        return () => {
            document.getElementById('myDiv')?.removeEventListener("contextmenu", handleRightClickMenu);
        };
    }, [messageBarVM, rightClickRef, allowUpdate, movementPatternState.selectedRows]);

    // for right click menu with move after begin
    const onRefreshRow = useCallback((newAllRows: any[]) => {
        setAllRows(newAllRows);
        movementPatternVM.updateSelectedRows([]);
        setShowMoveCursor(true);
    }, [movementPatternVM]);

    const onMoveCancel = useCallback(() => {
        setInitialAllRows(true);
        setAllRows(movementPatternState.movementPatternList);
        movementPatternVM.updateSelectedRows([]);
        setShowMoveCursor(false);
    }, [movementPatternState.movementPatternList, movementPatternVM]);

    const onSaveMove = useCallback(async (newAllRows: any[]) => {
        if (_.isEmpty(newAllRows)) return;

        setIsLoading(true);

        movementPatternVM.onApply(newAllRows).then((res) => {
            if (!res || !res.success) {
                messageBarVM.showError('Move failed.');
                setInitialAllRows(true);
                setIsLoading(false);

                movementPatternVM.updateSelectedRows([]);
                setShowMoveCursor(false);
            } else {
                movementPatternVM.searchAllMovementPatternList().then((data) => {
                    setInitialAllRows(true);
                    setIsLoading(false);

                    movementPatternVM.updateSelectedRows([]);
                    setShowMoveCursor(false);
                }).catch((e) => {
                    setInitialAllRows(true);
                    setIsLoading(false);

                    movementPatternVM.updateSelectedRows([]);
                    setShowMoveCursor(false);
                })
            }
        })
    }, [messageBarVM, movementPatternVM]);

    const handleAdd = useCallback(() => {
        movementPatternVM.onAddClick();
    }, [movementPatternVM]);

    const memoMovementPatternTable = useMemo(() => {

        return (
            <>
                {(allowUpdate) && <RightClickMenuWithMoveAfter disabled={_.isEmpty(getSelectedRows())}
                    rightClickRef={rightClickRef} selectedRows={getSelectedRows()} allRows={getAllRows()}
                    onSaveMove={onSaveMove} onCancel={onMoveCancel} onRefreshRow={onRefreshRow}
                    showConfirmMove={showMoveCursor} priorityName="priority" />}
                <div id="myDiv">
                    <NbisTable
                        id='movement-pattern-table'
                        headerLabel={MovementPatternConstant.Title.TITLE}
                        isNewColumnSetting={true}
                        columns={INITIAL_MOVEMENT_PATTERN_COL_DEF}
                        data={allRows ?? []}
                        showPaginator={false}
                        editable={false}
                        showAddIcon={allowCreate}
                        showDeleteButton={false}
                        showReloadIcon={false}
                        isScrollHighlighted={true}
                        selectionMode={false}
                        isRowHighligted={true}
                        handleSelectionChanged={handleSelectionChange}
                        onRowDoubleClick={(e: any, entity: MovementPatternEntity) => handleRowDoubleClick(entity)}
                        gridHeight="customHeight"
                        customHeight="calc(100vh - 75px)"
                        ref={gridRef}
                        // isRowDrag={true}
                        // onRowDragged={handleRowDrag}
                        rowSelection={showMoveCursor ? "single" : "multiple"}
                        // onBodyScroll={(e: any) => changeCursor("movement-pattern-table", getShowMoveCursor())}
                        onAddClick={handleAdd}
                        showCutCursor={showMoveCursor}
                    />
                </div>
            </>
        );
    }, [allowUpdate, getSelectedRows, rightClickRef, getAllRows, onSaveMove, onMoveCancel, onRefreshRow, showMoveCursor, allRows, allowCreate, handleSelectionChange, handleAdd, handleRowDoubleClick])

    useEffect(() => {
        if (initialAllRows && movementPatternState.movementPatternList && !_.isEmpty(movementPatternState.movementPatternList)) {
            setAllRows(movementPatternState.movementPatternList.map((movementPatternEntity, index) => ({
                ...movementPatternEntity,
                index: index || 0
            })));
            setInitialAllRows(false);
        }
    }, [allRows, initialAllRows, movementPatternState.movementPatternList]);

    return <><TableWrapper>
        {(isLoading) && <Loader Indicator="Spinner" size="Medium" />}
        {memoMovementPatternTable}
        {movementPatternState.forceRefresh && <></>}
    </TableWrapper>
    </>;
}

export default memo(MovementPatternTablePanel);
